import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../../apis/data";
import { queryKey } from "../../../enumerations/queryKey";
import { BannerResponse } from "./data";
import { apiGetBanner } from "./service";

export const useGetBanner = (options: any) => {
  return useQuery<BannerResponse[]>({
    queryKey: [queryKey.BANNER_LIST],
    queryFn: () =>
      apiGetBanner().then(
        (res: ApiResponse<BannerResponse[]>) => res.data.data
      ),
    ...options,
  });
};
